import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projects: [],
  currentProject: null,
}

const projectSlice = createSlice({
  name: 'projectList',
  initialState,
  reducers: {
    setProjects: (state, action) => {
      state.projects = action.payload.projects;
    },    
    addProject: (state, action) => {
      const newProject = {
        ...action.payload,
        userAnswers: [],      
      }
      state.projects.push(newProject)
      state.currentProject = newProject
    },
    archiveProject: (state, action) => {
      const projectIndex = state.projects.findIndex(p => p.id === state.currentProject.id)
      if (projectIndex !== -1) {
        state.projects[projectIndex].archived = action.payload
      }
    },
    deleteProject: (state, action) => {
      const projectIndex = state.projects.findIndex(p => p.id === action.payload)
      if (projectIndex !== -1) {
        state.projects.splice(projectIndex, 1)
      }
    },
    answerQuestion: (state, action) => {
      const projectIndex = state.projects.findIndex(p => p.id === state.currentProject.id);
      state.currentProject.userAnswers.push(action.payload);
      if (state.currentProject.userAnswers.length === state.currentProject.projectQuestions.length) {
        state.currentProject.step = 'creating_tasks';
      }
      state.projects[projectIndex] = state.currentProject;
    },
    startProject: (state, action) => {
      state.currentProject.step = 'in_progress'
      const projectIndex = state.projects.findIndex(p => p.id === state.currentProject.id)
      if (projectIndex !== -1) {
        state.projects[projectIndex] = state.currentProject
      }
    },
    restartProject: (state, action) => {
      state.currentProject.step = 'restart_project'
      const projectIndex = state.projects.findIndex(p => p.id === state.currentProject.id)
      if (projectIndex !== -1) {
        state.projects[projectIndex] = state.currentProject
      }
    },
    resetProjectCreation: (state) => {
      state.currentProject = {}
      state.currentProject.step = ''
    },
    setCurrentProject: (state, action) => {
      state.currentProject = state.projects.find(p => p.id === action.payload) || null
    },
  },
})

export const { 
  setProjects,
  addProject, 
  archiveProject,
  deleteProject,
  answerQuestion, 
  startProject,
  restartProject,
  resetProjectCreation, 
  setCurrentProject, 
} = projectSlice.actions

export default projectSlice.reducer;
